"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports["default"] = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var baseStyle = {
  px: 1,
  textTransform: 'reset',
  fontSize: 'xs',
  borderRadius: 'sm',
  fontWeight: 'bold'
};
var variants = exports.variants = {
  primary: {
    bg: 'primary.default',
    color: 'white'
  },
  warningLight: {
    bg: 'yellow.100',
    color: 'black'
  }
};
var defaultProps = {};
var _default = exports["default"] = (0, _merge["default"])(_theme["default"].components.Badge, {
  variants: variants,
  baseStyle: baseStyle,
  defaultProps: defaultProps
});